import TakeSurveyForm from './TakeSurveyForm'
import ProgressBar from 'FlowBuilder/components/ActionViews/Survey/ProgressBar'
import Preview from '../Preview'
import FieldEdit from '../FieldEdit'

import { useAct } from 'FlowBuilder/store'

export default function SurveyActionView() {
  const act = useAct()
  const templateFields = useSel(s => s.builder.flow.templateFields)
  const flowFields = useSel(s => s.builder.flow.flowFields)
  const context = { template: templateFields, flow: { ...flowFields, current_action_kind: 'survey' }, client: { brand: JSON.parse(window.ENV.CLIENT_BRAND)} }

  const selectedActionId = useSel(s => s.local.selectedActionId)
  const selectedPageNumber = useSel(s => s.local.selectedPageNumber)
  const surveyId = useSel(s => {
    const action = s.builder.flow.actions.find(a => a.id === selectedActionId)
    return action?.surveyId ?? 0
  })
  const questions = useSel(s => _.values(s.questions.entities).filter(q => q.surveyId === surveyId))

  const highestPageNumber = Object.values(questions)
    .filter(q => q.active)
    .reduce((max, q) => Math.max(max, q.pageNumber || 0), 0)

  const componentMap = useMemo(() => ({
    TakeSurveyForm: <>
      <TakeSurveyForm
        surveyId={surveyId}
        questions={questions}
        pageNumber={selectedPageNumber}
        onSubmit={() => Promise.resolve()}
      />
    </>,
    ProgressBar: <>
      <ProgressBar
        currentPage={selectedPageNumber}
        totalPages={highestPageNumber}
      />
    </>,
    FieldEdit,
  }), [surveyId, selectedPageNumber])

  useEffect(() => {
    if (!selectedPageNumber) {
      act.builder.selectAction(selectedActionId, { pageNumber: 1 })
    }
  }, [selectedPageNumber])

  return <Preview context={context} componentMap={componentMap} />
}
